import React from 'react';

const ScssIcon = () => {
  return <img src='/skill-icons/scss.png' alt='scss-logo' />;
};

export default ScssIcon;
